export default __webpack_public_path__ + "static/A_rare_silk_nearly_lost_through_war-30ff6e0c1f48985ed6776e41bb1b2d27.jpg";